import React from 'react';
import { Box, Heading, VStack, Text, Container, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import Profile from '../components/Profile';
import { FiChevronRight } from 'react-icons/fi';

const ProfilePage = () => {
  return (
    <Box
      minH="100vh"
      bg="gray.50"
      pt={{ base: '20px', lg: '10px' }}
      pb="150px"
      px={{ base: 4, md: 8 }}
      transition="all 0.3s"
    >
      <Container maxW="container.xl">
        <VStack spacing={8} align="stretch">
          {/* Breadcrumbs & Title */}
          <Box>
            <Breadcrumb spacing="8px" separator={<FiChevronRight color="gray.500" />} fontSize="sm" color="gray.500" mb={2}>
              <BreadcrumbItem>
                <BreadcrumbLink href="/">Home</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink href="#">My Profile</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
            
            <Heading as="h1" size="xl" color="gray.800">
              Account Settings
            </Heading>
            <Text color="gray.500" mt={1}>
              Manage your personal information and preferences
            </Text>
          </Box>

          {/* Profile Form Component */}
          <Profile />
        </VStack>
      </Container>
    </Box>
  );
};

export default ProfilePage;
